module.exports = __webpack_public_path__ + "img/icon3.eef1baf8.png";